import { useRouter } from "next/router";
import { Card, TextStyle, TextField } from "@shopify/polaris";

function WidgetTranslations({
  translations = [],
  shopOrigin,
  scopes,
  hasFeature,
  getMinPlanForFeature,
  ...props
}) {
  const router = useRouter();
  const isWidgetThemeRequired = (translation) => {
    let updateButtonElement = (
      <span
        style={{ color: "#2c6ecb", cursor: "pointer" }}
        onClick={() => {
          router.push("/widget-installation", "/widget-installation", {
            shallow: true,
          });
        }}
      >
        Click here to update to latest version.
      </span>
    );
    let updateWidget = {
      disabled: true,
      helpText: (
        <div>
          This feature is available only for Loop snippet V4.9 or above.{" "}
          {updateButtonElement}
        </div>
      ),
    };
    if (
      translation &&
      translation.key &&
      translation.key === "widget_price_label_text"
    ) {
      if (props.snippet_version && props.snippet_version < 4.992) {
        return updateWidget;
      }
    } else if (
      translation &&
      translation.key &&
      translation.key === "widget_add_to_cart_button_for_one_time_purchase"
    ) {
      if (props.snippet_version && props.snippet_version < 4.992) {
        return updateWidget;
      }
    } else if (
      translation &&
      translation.key &&
      translation.key === "widget_add_to_cart_button_for_subscription"
    ) {
      if (props.snippet_version && props.snippet_version < 4.992) {
        return updateWidget;
      }
    } else if (
      translation &&
      translation.key &&
      translation.key === "widget_price_label_text"
    ) {
      if (props.snippet_version && props.snippet_version < 4.992) {
        return updateWidget;
      }
    }
    return {};
  };

  const handleTextFieldChange = (index, _newValue) => {
    let data = translations.slice();
    data[index].value = _newValue;
    props.changeInTranslations(data);
  };

  return (
    <div>
      {translations.map((translation, index) => {
        let _value = translation.value;
        let { disabled, helpText } = isWidgetThemeRequired(translation);
        return (
          <Card.Section key={index}>
            <TextStyle variation="strong">
              <div
                style={{
                  marginBottom: "8px",
                  width: "600px",
                  maxWidth: "100%",
                }}
              >
                {translation.name}
              </div>
            </TextStyle>

            {translation.input_element === "INPUT" ? (
              <TextField
                label=""
                helpText={helpText || translation.description}
                value={_value}
                disabled={disabled || !props.hasWidgetWriteAccess}
                onChange={(_newValue) =>
                  handleTextFieldChange(index, _newValue)
                }
                autoComplete="off"
              />
            ) : null}

            {translation.input_element === "TEXTAREA" ? (
              <TextField
                label=""
                multiline={3}
                value={_value}
                helpText={helpText || translation.description}
                disabled={disabled || !props.hasWidgetWriteAccess}
                onChange={(_newValue) =>
                  handleTextFieldChange(index, _newValue)
                }
                autoComplete="off"
              />
            ) : null}
          </Card.Section>
        );
      })}
    </div>
  );
}
export default WidgetTranslations;
